import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "title", "subtitle", "toggleButton"]

  connect() {
    this.updateTexts()
    this.updateFormVisibility()
  }

  hideServiceDetails() {
    const form = this.element.querySelector('form')
    if (form) {
      const withServiceInput = form.querySelector('input[name*="[with_service_details]"]') || form.querySelector('input[name*="[with_burial_service_details]"]')

      if (withServiceInput.value === "true") {
        withServiceInput.value = "false"
      } else {
        withServiceInput.value = "true"
      }
      
      this.updateTexts()
      this.updateFormVisibility()
    }
  }

  updateTexts() {
    const withServiceInput = this.element.querySelector('input[name*="[with_service_details]"]') || this.element.querySelector('input[name*="[with_burial_service_details]"]')
    const buttonText = this.hasToggleButtonTarget
      ? this.toggleButtonTarget.querySelector('span[name="button-text"]')
      : null

    if (withServiceInput && withServiceInput.value === "false") {
      if (this.hasTitleTarget) this.titleTarget.textContent = "Show Service Details?"
      if (this.hasSubtitleTarget) this.subtitleTarget.textContent = "Your service details are currently hidden. You can click the button below to show them on your tributes page."
      if (buttonText) buttonText.textContent = "Show all service details"
    } else {
      if (this.hasTitleTarget) this.titleTarget.textContent = "Not Having a Service?"
      if (this.hasSubtitleTarget) this.subtitleTarget.textContent = "If you'd rather not include any service details, simply click the button below. You can always change your mind later."
      if (buttonText) buttonText.textContent = "Don't show any service details on my page."
    }
  }

  updateFormVisibility() {
    const withServiceInput = this.element.querySelector('input[name*="[with_service_details]"]') || this.element.querySelector('input[name*="[with_burial_service_details]"]')
    const formContainer = this.hasFormTarget ? this.formTarget : null
    
    if (formContainer) {
      if (withServiceInput && withServiceInput.value === "false") {
        formContainer.classList.add('opacity-50', 'pointer-events-none')
      } else {
        formContainer.classList.remove('opacity-50', 'pointer-events-none')
      }
    }
  }
}
